import React from "react"
import { Ridecell } from "@ridecell/web-sdk"
import useGlobalContext from "./useGlobalContext"

const useCustomer = () => {
  const {
    state: { tenantSettings },
    setAuthenticated,
    setError,
    setCurrentUser,
    setMfaDialog,
    toggleBackdrop,
  } = useGlobalContext()

  const mfaEnabled =
    tenantSettings.mfaEnabled && tenantSettings.mfaEnabledForStaff

  const login = async ({ username, password, deviceId }) => {
    try {
      toggleBackdrop(true)
      const resp = await Ridecell.login({
        email: username,
        password,
        ...(mfaEnabled && { deviceId: deviceId }),
      })
      if (resp["nonce"]) {
        setMfaDialog(true)
      } else if (!resp["is_staff"]) {
        setAuthenticated(true)
        setCurrentUser(resp)
      }
    } catch (e) {
      setError(e)
    } finally {
      toggleBackdrop(false)
    }
  }

  const fetchCustomer = async () => {
    try {
      toggleBackdrop(true)
      const resp = await Ridecell.getCustomer({ fetchUpdatedCustomer: true })
      setCurrentUser(resp)
      return resp
    } catch (e) {
      setError(e)
      return e
    } finally {
      toggleBackdrop(false)
    }
  }

  const logout = async () => {
    try {
      toggleBackdrop(true)
      await Ridecell.logout()
      setCurrentUser(null)
    } catch (e) {
      setError(e)
    } finally {
      toggleBackdrop(false)
      setAuthenticated(false)
    }
  }

  return { login, logout, fetchCustomer }
}

export default useCustomer
